import { render, staticRenderFns } from "./idPc.vue?vue&type=template&id=2df28b1d&scoped=true&"
import script from "./idPc.vue?vue&type=script&lang=js&"
export * from "./idPc.vue?vue&type=script&lang=js&"
import style0 from "./idPc.vue?vue&type=style&index=0&id=2df28b1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df28b1d",
  null
  
)

export default component.exports